import { createContext } from 'react'
import { SocketContextType } from './socketTypes'

export const SocketContext = createContext<SocketContextType | undefined>(undefined)
